function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var HudLayer = require('../hud-layer');
var SpringDeploymentTemplate = require('./spring-deployment.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var SpringDeploymentOverlay = /*#__PURE__*/function () {
  function SpringDeploymentOverlay(app, mod) {
    _classCallCheck(this, SpringDeploymentOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.overlay = new SaitoOverlay(app, mod);
  }
  return _createClass(SpringDeploymentOverlay, [{
    key: "hide",
    value: function hide() {
      this.visible = false;
      this.overlay.hide();
    }
  }, {
    key: "pullHudOverOverlay",
    value: function pullHudOverOverlay() {
      HudLayer.pullHudOverOverlay.call(this);
    }
  }, {
    key: "pushHudUnderOverlay",
    value: function pushHudUnderOverlay() {
      HudLayer.pushHudUnderOverlay.call(this);
    }
  }, {
    key: "updateInstructions",
    value: function updateInstructions(msg) {
      try {
        document.querySelector('.spring-deployment-overlay .instructions').innerHTML = msg;
      } catch (err) {}
    }
  }, {
    key: "render",
    value: function render() {
      var faction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var mycallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      this.visible = true;
      this.overlay.show(SpringDeploymentTemplate(faction));
      this.pushHudUnderOverlay();
      var tips = ['TIP: you need more squadrons in the sea adjacent to a port than defending it to assault...', 'TIP: you cannot assault a key without a line-of-controlled spaces connecting it to another controlled key...', 'TIP: once your ships are at sea, the "Move Across Seas" option lets you move units overseas...', 'TIP: you can only move into independent spaces, or those where you allied with or at war with its controller', 'TIP: when assaulting fortified troops you need 2 units for each dice roll (round up)', 'TIP: you cannot assault a space in the same turn you move into positition to assault it', "TIP: you can't be excommunicated by the Papacy if you don't go to war with them and don't ally with the Ottomans", 'TIP: factions get -1 card each turn if excommunicated or stuck in an unfinished Foreign War', 'TIP: find something difficult to understand? suggest tips to include on this help screen...'];
      if (this.mod.game.state.round == 1 && faction == 'ottoman') {
        this.updateInstructions('You start at War with Hungary. Why not deploy from Istanbul to Nezh and try to seize Belgrade?');
      }
      if (this.mod.game.state.round == 1 && faction == 'france') {
        this.updateInstructions('France starts at War with the Hapsburgs and Papacy - the independent key of Metz is also within reach of Paris...');
      }
      if (this.mod.game.state.round == 1 && faction == 'papacy') {
        this.updateInstructions('The Papacy starts at War with France. Manage that conflict while fighting the Protestants and controlling strategic keys like Florence and Milan...');
      }
      if (this.mod.game.state.round == 1 && faction == 'england') {
        this.updateInstructions('England usually deploys north to pacify Scotland. Your home card will let you declare war on the Scots, but remember you need more squadrons in the North Sea than are defending Edinburgh to assault the city...');
      }
      if (this.mod.game.state.round == 1 && faction == 'hapsburg') {
        this.updateInstructions('Move infantry into Germany to slow the Protestants, or subdue independent keys for VP and bonus cards...');
      }
      if (this.mod.game.state.round > 1) {
        this.updateInstructions(tips[Math.floor(Math.random() * tips.length)]);
      }
      this.attachEvents(mycallback);
      this.pushHudUnderOverlay();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var mycallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    }
  }]);
}();
module.exports = SpringDeploymentOverlay;